import { graphql } from '~/lib/graphql'

export const PlanAttributes = graphql(/* GraphQL */ `
  fragment PlanAttributes on Plan {
    attributes
    mealPeriod
    freeFlow3hours: isInSpecial(specialId: "100426")
    tags(tagIds: ["3239", "3533"]){
      tagId
      name
      type
    }
  }
`)

export const SeatAttributes = graphql(/* GraphQL */ `
  fragment SeatAttributes on Seat {
    smokingAllowed
    attributes
    seatTypeLabel
    childUse
  }
`)
